
import {Options, Vue, PropOptions} from 'vue-class-component';
import 'vue3-carousel/dist/carousel.css';

import {Carousel, Navigation, Slide} from 'vue3-carousel';
import axios from "axios";

@Options({
    components: {
        Carousel,
        Slide,
        Navigation,
    },
    props: {
        displayOnBusinessLifeAwardsPage: Boolean,
        displayOnContactPage: Boolean,
        displayOnMainPage: Boolean,
    }
})
export default class Gallery extends Vue {
    isShowGalleryPopup = false
    galleryIndex = 0
    _display_on_business_life_awards_page = false
    _display_on_contact_page = false
    _display_on_main_page = false
    galleryImages: any = []
    lightBoxGalleryImages: any = []

    showGallery(index: number) {
        this.galleryIndex = index
        this.isShowGalleryPopup = true
        window.addEventListener('keydown', this.handleKeydown);

    }

    closeGallery() {
        this.isShowGalleryPopup = false
        window.removeEventListener('keydown', this.handleKeydown);
    }

    handleKeydown(e: any) {
        switch (e.keyCode) {
            case 37:
                this.back();
                break;
            case 39:
                this.next();
                break;
        }
    }

    back() {
        if (this.galleryIndex != 0) {
            this.galleryIndex--
        }
    }

    next() {
        if (this.galleryIndex != this.galleryImages.length - 1) {
            this.galleryIndex++
        }
    }

    mounted() {
        this.getMediaData()
        //@ts-ignore
        console.log('result',this.displayOnMainPage); // not working

    }

    getMediaData() {
        axios.get('/api/v1/assets?per_page=1000').then((data) => {
            if (data?.data?.data.length > 0) {
                data.data.data.map((media: any) => {
                    media.files.map((image: any) => {
                        //@ts-ignore
                        if(this.displayOnBusinessLifeAwardsPage && media.display_on_business_life_awards_page){
                            this.galleryImages.push(image)
                            this.lightBoxGalleryImages.push({src: image.url})
                            //@ts-ignore
                        }else if(this.displayOnContactPage && media.display_on_contact_page){
                            this.galleryImages.push(image)
                            this.lightBoxGalleryImages.push({src: image.url})
                            //@ts-ignore
                        }else if(this.displayOnMainPage && media.display_on_main_page){
                            this.galleryImages.push(image)
                            this.lightBoxGalleryImages.push({src: image.url})
                        }
                    })
                })
            }
        })
    }

}
